import { OpenModalPayload } from '@chegg-wt/core/state/modals/types'
import { UserClickPayload } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import { Project, Option } from '@chegg-wt/core/types/core'

export interface ExportModalStateProps {
  selectedCitations: Citation[]
  citations: Citation[]
  isLoggedIn: boolean
  isPro: boolean
}

export interface ExportModalDispatchProps {
  handleClose: () => void
  openModal: (payload: OpenModalPayload) => void
}

export interface ExportModalProps
  extends ExportModalStateProps,
    ExportModalDispatchProps {
  exportTabIds?: ExportTabId[]
  currentStyle?: string
  handleComplete?: (exportResult: ExportResult) => void
  userClick: (payload: UserClickPayload) => void
}

export interface ExportTabProps {
  exportTabIds?: ExportTabId[]
  projects: Project[]
  citations: Citation[]
  includeMove: boolean
  isPro: boolean
  exportCitations: (to: string, citations: Citation[]) => void
  moveCitations: (projectId: string, citations: Citation[]) => void
  handleClose: () => void
  handleComplete?: (exportResult: ExportResult) => void
  openModal: (payload: OpenModalPayload) => void
}

export interface DropdownOption extends Option {
  gated: boolean
}

export interface ExportTabId {
  id: string
  gated?: boolean
}

export enum ExportType {
  export,
  move,
}

export interface Move {
  type: ExportType.move
  citations: Citation[]
  projectId: string
  projectName: string
}

export interface Export {
  type: ExportType.export
  citations: Citation[]
}

export type ExportResult = Export | Move
